import { render, staticRenderFns } from "./IssueTrackerList.vue?vue&type=template&id=93dbd49c&scoped=true&"
import script from "./IssueTrackerList.vue?vue&type=script&lang=js&"
export * from "./IssueTrackerList.vue?vue&type=script&lang=js&"
import style0 from "./IssueTrackerList.vue?vue&type=style&index=0&id=93dbd49c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93dbd49c",
  null
  
)

export default component.exports